import React from "react";
import { Box, Typography, Button, ThemeProvider, createTheme, CssBaseline, Container } from '@mui/material';
import { useTranslation } from "react-i18next";

const ErrorPage = () => {
  const defaultTheme = createTheme();
  const { t } = useTranslation();

  const handleReconnect = () => {
    try {
      window.location.href = '/';

    } catch (error) {
      console.error('Error during reconnection:', error);

      window.location.reload();
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Container 
        width="100vh" 
        sx={{ 
          height: "100vh", 
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Container component="main" maxWidth="sm">
          <Box
            sx={{  
              minHeight: '100vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img 
              src='/LoginAifel.svg' 
              style={{
                maxWidth: '18.75rem',
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                marginTop: '0.625'
              }} 
              alt="Login Logo" 
            />
            <Box
              sx={{  
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography 
                variant="h5" 
                component="h4" 
                sx={{
                  mt: 3,
                  mb: 2,
                  color: 'grey',
                  fontWeight: 'bold',
                  textAlign: 'center'
                }}
              >
                {t("you_are_already_connected_in_another_tab")}
              </Typography>
            </Box>
            
            <Button
              onClick={handleReconnect}
              type="submit"
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                backgroundColor: '#77dd48',
                color: 'white',
                width: 'auto',
                px: 2,
                '&:hover': {
                  backgroundColor: '#60d744'
                }
              }}
            >
              {t("reconnect_to_this_tab")}
            </Button>
          </Box>
        </Container>
      </Container>
    </ThemeProvider>
  );
};

export default ErrorPage;